import { render, staticRenderFns } from "./comprehensiveStatistics.vue?vue&type=template&id=5459af6a&scoped=true"
import script from "./comprehensiveStatistics.vue?vue&type=script&lang=js"
export * from "./comprehensiveStatistics.vue?vue&type=script&lang=js"
import style0 from "./comprehensiveStatistics.vue?vue&type=style&index=0&id=5459af6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5459af6a",
  null
  
)

export default component.exports